import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiBaseUrlService } from './api-base-url.service';

@Injectable({
  providedIn: 'root',
})
export class ApiCallService {
  headers: HttpHeaders;

  constructor(
    private http: HttpClient,
    private apiBaseUrlService: ApiBaseUrlService
  ) {
    this.headers = new HttpHeaders();
  }

  setCustomHeader(headers: any) {
    const headersArray = headers ? headers : {};
    if (Object.keys(headersArray).filter((x) => x == 'Content-Type').length <= 0) {
      headersArray['Content-Type'] = 'application/json';
    }
    this.headers = new HttpHeaders(headersArray);
  }
  
  public GetJson(filePath: string): Observable<any> {
    return this.http.get(filePath);
  }
  public Get(url: string, params?: any, headers?: any, responseType?: any): Observable<any> {
        this.setCustomHeader(headers);
        return this.http.get(this.apiBaseUrlService.getAspNetBaseUrl() + url, {
          headers: this.headers,
          params,
          responseType: responseType ?? 'json',
        });
  }
  public Post(url: string, params: any, headers?: any, responseType?: any): Observable<any> {
    try {
      this.setCustomHeader(headers);
      return this.http.post(this.apiBaseUrlService.getAspNetBaseUrl() + url, params, {
          headers: this.headers,
          responseType: responseType ?? 'json',
        });
    } catch (error) {
      throw error;
    }
  }

  public createLead(url: string, params: any, headers?: any, responseType?: any): Observable<any> {
    try {
      var leadheadersArray = headers ? headers : {};
      leadheadersArray['secret-key'] = 'd0c5c6bc7d49de013b09e69c031f437c';
      leadheadersArray['access-key'] = 'ee71837c527a4091bfc34aa85bb41853';
      leadheadersArray['Content-Type'] = 'application/json';
      leadheadersArray['Access-Control-Allow-Origin'] = '*';
      return this.http.post(url, params, {
        headers: leadheadersArray,
        responseType: responseType ?? 'json',
      });
    } catch (error) {
      throw error;
    }
  }

  public Put(url: string, params: any, headers?: any, responseType?: any): Observable<any> {
        this.setCustomHeader(headers);
        return this.http.put(this.apiBaseUrlService.getAspNetBaseUrl() + url, params, {
          headers: this.headers,
          responseType: responseType ?? 'json'
        });
  }

  public Patch(url: string, params: any, headers?: any, responseType?: any): Observable<any> {
        this.setCustomHeader(headers);
        return this.http.patch(this.apiBaseUrlService.getAspNetBaseUrl() + url, params, {
          headers: this.headers,
          responseType: responseType ?? 'json',
        });
  }

  public uploadFileOnCDN(url: string, params: any,filepath: any, responseType?: any): Observable<any> {
    try {
       
      return this.http.post(`${this.apiBaseUrlService.getAspNetBaseUrl()}/v1/rest/en-us/question/upload-file-on-cdn`, params, {
        headers: new HttpHeaders({}),
        responseType: 'json'
      });
    } catch (error) {
      throw error;
    }
  }

  
}
